<template>
  <div id="ContainerHcpcsCPT">

     <h4 class="page-title text-truncate">
      {{$t(this.$attrs.editMode ? 'Shared.Edit' : 'Shared.Add')}} {{$t('Incident.IncPartEmplType')}}
    </h4>

    <b-row class="mt-3">
      <b-col lg="3" md="3" sm="12">
          <MdEdit
              ref="descriptionInput"
              v-bind:Name="'descriptionInput'"
              v-model="EmployeeType.description"                    
              v-bind:Label="$t('employeeType.EmployeeType')"
              v-bind:Id="'input_e_des'"
              v-bind:isReadOnly=this.$route.params.isSystemType 
            />
      </b-col>
    </b-row> 
    <b-row class="mt-3">
      <b-col lg="3" md="3" sm="12">
        <MdCheckBox
            v-bind:Label="$t('employeeType.ShowInNotes')"
            v-bind:Name="'showinNotes'"
            v-bind:ClassProp="'AlignCheck'"
            v-bind:CheckedValue="true"
            v-bind:UncheckedValue="false"
            v-model="EmployeeType.showInNotes"
            v-bind:isReadOnly=this.$route.params.isSystemType                
        />
      </b-col> 
      
      <b-col md="3" lg="3" sm="12" >
        <MdCheckBox
            v-bind:Label="$t('employeeType.InternalType')"
            v-bind:Name="'checkbox-InternalType'"
            v-bind:ClassProp="'AlignCheck'"
            v-bind:CheckedValue="true"
            v-bind:UncheckedValue="false"
            v-model="EmployeeType.systemType"
            v-bind:isReadOnly=this.$route.params.isSystemType
          />
      </b-col>
      <b-col md="3" lg="3" sm="12" >
        <MdCheckBox
            v-bind:Label="$t('employeeType.IsProvider')"
            v-bind:Name="'checkbox-IsProvider'"
            v-bind:ClassProp="'AlignCheck'"
            v-bind:CheckedValue="true"
            v-bind:UncheckedValue="false"
            v-model="EmployeeType.provider"
            v-bind:isReadOnly=this.$route.params.isSystemType
          />
      </b-col>
      <b-col md="3" lg="3" sm="12" >
        <MdCheckBox
            v-bind:Label="$t('employeeType.IsNurse')"
            v-bind:Name="'checkbox-IsNurse'"
            v-bind:ClassProp="'AlignCheck'"
            v-bind:CheckedValue="true"
            v-bind:UncheckedValue="false"
            v-model="EmployeeType.nurse"
            v-bind:isReadOnly=this.$route.params.isSystemType
          />
      </b-col>
    </b-row>
        
    <div class="space-actions"></div>
    <div class="page-actions">      
      <MdButton
          v-bind:Label="$t('Shared.Back')"
          v-bind:Name="'btnbtn_save_EmployeeTypelist'"
          v-bind:ClassProp="'secondary mx-2 btn-login'"
          v-on:click="DiscardChanges"/>    
      <MdButton v-if="this.$route.params.isSystemType == false"
          v-bind:Label="$t('Shared.Save')"
          v-bind:ClassProp="(this.isReadOnlyEmployeeType)?'primary mx-2':'primary btn-login mx-2'"
          v-on:click="SaveOrEdit"
          v-bind:isReadOnly="this.$route.params.isSystemType"
          v-bind:Name="'btn_save_EmployeeType'"/>
    </div>

  </div>
</template>

<script>


import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js'
import EmployeeTypeService from '@/services/employeetypes.service'
import { EventBus } from '../../../../event-bus.js';
import Permission from '@/common/Permission'
//import Utils from '@/common/utils'

  let elemSaveBtn = '';
  export default {
    beforeRouteLeave(to, from, next) {
      if (this.pendingChanges) {
          this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
          title: this.$t('Admission.Admission'),
          okTitle: this.$t('Shared.BtnSave'),
          cancelTitle: this.$t('Shared.BtnDismiss'),
          footerClass: 'p-2',
          titleClass: 'modal-title modal-type-warning'
        })
        .then(async value => {
            if(!value){
                next();
            } else {
                await this.SaveOrEdit();
                next();
            }
        })		
      } else {
          next()
      }
    },

  name: 'EmployeeType',
  mixins: [ShowMessage, DBFunctions, Permission],
  data(){
    return{
      parameter:{
          SearchCriteria:'',
          PageNumber : 1,
          PageSize:0,         
      },
      EmployeeType:{
        code:"",
        descrition:"",
        showInNotes:false,
        systemType: false  ,
        provider:false,
        nurse:false    
      },
      pendingChanges:false,
      isReadOnlyEmployeeType:false,
      isCodeValid:true,
      OptionsRightMenu:{
        visible:false,
        ItemsList:[],
        btnvisible:false,
        itemdisabled: false,
        PatientCode:'',
        Mode:this.edit_mode,
        favButtonAtion:false          
      },
    }
  },

  methods:{

    DiscardChanges(){
       this.checkExistFavorite('/app/employeetypes');
       this.$router.push({name: "employeeTypeList"});
    },

    AddEmployeeType(){
      this.$emit('load', true);
      EmployeeTypeService.AddEmployeeType(this.EmployeeType)
        .then((response) => {
            if(response.status == '200'){
              this.EmployeeType = response.data; 
              this.pendingChanges = false;   
              this.$emit('load', false);
              /*if(!this.OffRoute){
                  this.GotoAdmissionList();
              }*/
              this.$router.push({name: "employeeTypeList"}).catch(()=>{});
            
              setTimeout(() => 
                this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                  title: this.$t('Msg.Success'),
                  autoHideDelay: 5000,
                  variant: "success"
                })
              , 50); 
            }                             
        })				
        .catch((error) => {
            this.$emit('load', false);   
            elemSaveBtn.removeAttribute("disabled");  
            this.showResponseErrorMessage(error);
        }); 
    },


    EditEmployeeType(){
      this.$emit('load', true);
      EmployeeTypeService.UpdateEmployeeType(this.$route.params.id,this.EmployeeType)
        .then((response) => {
            if(response.status == '200'){
              this.EmployeeType = response.data; 
              this.pendingChanges = false;   
              this.$emit('load', false);
              /*if(!this.OffRoute){
                  this.GotoAdmissionList();
              }*/
              this.$router.push({name: "employeeTypeList"}).catch(()=>{});
            
              setTimeout(() => 
              this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                title: this.$t('Msg.Success'),
                autoHideDelay: 5000,
                variant: "success"
              })
              , 50); 
            }                             
        })
        .catch((error) => {   
            this.$emit('load', false);
            elemSaveBtn.removeAttribute("disabled");  
            this.showResponseErrorMessage(error);
        }); 
    },

    getEmployeeType(){    
      if(this.$attrs.editMode){
        var ShNotes = false;
        this.$emit('load', true);     
        EmployeeTypeService.GetEmployeeType(this.$route.params.id)
        .then((response) => {
            if(response.status == '200' && response.data){
                if(response.data.showInNotes != null && response.data.showInNotes != "" && response.data.showInNotes.length > 0){
                    if(response.data.showInNotes == "Y"){
                        ShNotes = true;
                    }
                }
              this.EmployeeType = response.data;  
              this.EmployeeType.showInNotes = ShNotes;
            }   
              this.$emit('load', false);                     
        })
        .catch((error) => {                    
            this.$emit('load', false);        
            this.showResponseErrorMessage(error);    
        }); 
      }
    },

    DoAction(){     
      !this.$attrs.editMode ? this.AddEmployeeType() : this.EditEmployeeType(); 
    },

    SaveOrEdit(){ 
        if (this.validate_required()) {
          this.DoAction();
        } else {
          this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");          
        }
    },

    validate_required() {
      return true;
    },

    checkUserAction() {
      if (elemSaveBtn.disabled) {
        elemSaveBtn.removeAttribute('disabled');
      }
    },

    beforeWindowUnload(e) {
			if (this.pendingChanges) {
				e.preventDefault()
				e.returnValue = ''	
			}
		}
  },

  created(){
    EventBus.$on("onChanged", function (e) { 
        this.pendingChanges = e.Changed;      
        this.checkUserAction();
    }.bind(this));
    window.addEventListener('beforeunload', this.beforeWindowUnload);
  },

  mounted(){
    this.OptionsRightMenu.ItemsList = [];
    let layoutStatus = this.$store.state.layoutStatus;
    switch(layoutStatus) {
      case 'L0R1':
        this.OptionsRightMenu.favButtonAtion = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
      break;
      case 'L1R0':
      case 'L1R1':
          this.OptionsRightMenu.btnvisible = false;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
      break;
      default:
          this.OptionsRightMenu.favButtonAtion = false;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
    }
    this.getEmployeeType();
    setTimeout( function() {
        elemSaveBtn = document.getElementById('btn_save_EmployeeType');
        if(elemSaveBtn) {
            elemSaveBtn.setAttribute('disabled', '');
        }
    }, 50, this ); 
    
    if (!this.$attrs.editMode) {
      this.$nextTick(() => {
        setTimeout(() =>  this.$refs.descriptionInput.setFocus(), 500);
      });
    }

  },

  destroyed(){
    this.OptionsRightMenu.ItemsList = [];
    this.OptionsRightMenu.Mode = false;
    this.OptionsRightMenu.visible = false; 
    this.$emit('getVisibleMenu', this.OptionsRightMenu);
  },

  beforeDestroy () {
      window.removeEventListener('beforeunload', this.beforeWindowUnload);
  },
   
};
</script>


